import MUIBox from "@mui/material/Box";

const Box = MUIBox;

export default Box;
